import React, { useState } from "react";
import Tooltip from "@mui/material/Tooltip";

interface CopyableTextProps {
  text?: string;
}

const CopyableText: React.FC<CopyableTextProps> = ({ text }) => {
  const [tooltipTitle, setTooltipTitle] = useState("Click to copy");

  const safeText = text != null ? String(text) : "";

  if (!safeText)
    return (
      <span style={{ display: "block", textAlign: "center", width: "100%" }}>
        -
      </span>
    );
  const truncatedText =
    safeText.length > 10 ? safeText.substring(0, 10) + "..." : safeText;

  const handleCopy = async () => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(safeText);
      } else {
        const textArea = document.createElement("textarea");
        textArea.value = safeText;
        textArea.style.position = "fixed";
        textArea.style.left = "-9999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
      }
      setTooltipTitle("Copied!");
      setTimeout(() => setTooltipTitle("Click to copy"), 1500);
    } catch (error) {
      console.error("Failed to copy text:", error);
      setTooltipTitle("Error");
      setTimeout(() => setTooltipTitle("Click to copy"), 1500);
    }
  };

  return (
    <Tooltip title={tooltipTitle} arrow>
      <span
        style={{
          cursor: "pointer",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        onClick={handleCopy}
      >
        {truncatedText}
      </span>
    </Tooltip>
  );
};

export default CopyableText;
